import { useHistory, useParams } from 'react-router-dom';
import { GO_TO_PRESCRIPTION_PAD, PPRouterProps } from '../../../../../routes/paths';
import { track } from '../../../../../tracking';
import { followUpIcon } from '../../../../common/Icons';
import { IMilestoneHistory } from '../../../../common/types/milestones';
import { useDispatch } from 'react-redux';
import { clearMilestonConfirmationDialog } from '../../../../common/milestoneModals';
import { AP } from '../../../../../pages/Appointments';
import { IVaccineStatus } from '../../../../../api/fetchVaccineSchedule';

const PadBottomStrip: React.FC<{
    clearSelections: (clearedMilestones?: IMilestoneHistory[]) => void;
    openFollowUp?: () => void;
    currSchedule?: 'plan' | 'otherVaccs';
    loading?: boolean;
    onSave?: () => void;
}> = ({ clearSelections, openFollowUp, currSchedule, loading, onSave }) => {
    const history = useHistory();
    const params: PPRouterProps = useParams();
    const dispatch = useDispatch();

    const onContinue = (): void => {
        track('VACCINATION_CONTINUE');
        if (!params.pxId) {
            history.replace('/');
        }

        history.push(GO_TO_PRESCRIPTION_PAD(params.pxId, 'edit'));
    };

    return (
        <div className="flex items-center justify-between absolute rounded-8 gap-8 bg-actionPrimary bottom-24 inset-x-10 px-16 py-8 cta-row z-10">
            <button
                onClick={() => dispatch(clearMilestonConfirmationDialog(clearSelections))}
                className="text-btn-v2 px-16 py-8 btn--small padv2-main-panel"
            >
                Clear
            </button>

            <div className="flex gap-16 items-center">
                {currSchedule && currSchedule !== 'otherVaccs' && (
                    <div
                        className="border flex items-center gap-8 rounded-8 font-700 border-white px-16 py-8 text-white cursor-pointer"
                        onClick={() => openFollowUp && openFollowUp()}
                    >
                        {followUpIcon('fill-white')}
                        <p className="text-14">Set Vaccine Reminder</p>
                    </div>
                )}
                {onSave ? (
                    <button
                        onClick={onSave}
                        className="px-16 py-8 btn--small primary-btn-v2 tooltip-wrapper"
                    >
                        {loading && (
                            <div className="w-20 h-20">
                                <svg className="circular-loader" viewBox="25 25 50 50">
                                    <circle
                                        className="loader-path"
                                        cx="50"
                                        cy="50"
                                        r="20"
                                        fill="none"
                                        stroke="#000000"
                                        stroke-width="3"
                                    ></circle>
                                </svg>
                            </div>
                        )}
                        <p>Save Changes</p>
                    </button>
                ) : (
                    <button
                        onClick={onContinue}
                        className="px-16 py-8 btn--small primary-btn-v2 tooltip-wrapper"
                    >
                        <div className="flex items-center justify-center w-16 h-16">
                            <svg
                                className="w-16 h-16 fill-actionPrimary"
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                                style={{ rotate: '180deg' }}
                            >
                                <path d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                            </svg>
                        </div>
                        <p>Continue To Prescription</p>
                    </button>
                )}
            </div>
        </div>
    );
};

export default PadBottomStrip;
